
const fieldHasErrors = (summary: any, field: string) => {
    return summary[field] && summary[field].length > 0;
};

export { fieldHasErrors };